module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tranvelution"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "Tranvelution"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tranvelution_banner"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v(_vm._s(_vm.$t('travelution_banner')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('travelution_content')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('travelution_content1')))])]), _vm._v(" "), _c('div', {
    staticClass: "tranvelution_about_ifree"
  }, [_c('div', {
    staticClass: "tranvelution_about_ifree_wrap"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v(_vm._s(_vm.$t('travelution_about_us')))]), _vm._v(" "), _c('div', {
    staticClass: "tranvelution_about_ifree_content"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_c('br'), _vm._v(_vm._s(_vm.$t('travelution_about_us_content'))), _c('br'), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.$t('travelution_about_us_content_right')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_c('br'), _vm._v(_vm._s(_vm.$t('travelution_about_us_content1')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tranvelution_content"
  }, [_c('div', {
    staticClass: "tranvelution_content_wrap"
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v(_vm._s(_vm.$t('travelution_system')))]), _vm._v(" "), _c('div', {
    staticClass: "tranvelution_about_ifree_content"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('travelution_system_tittle')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('travelution_system_tittle1')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tranvelution_content_system"
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [(this.lang == 'tc') ? _c('img', {
    staticClass: "system_img",
    attrs: {
      "src": require("../../assets/about_us/system_tc@2x.png")
    }
  }) : (this.lang == 'sc') ? _c('img', {
    staticClass: "system_img",
    attrs: {
      "src": require("../../assets/about_us/system_sc@2x.png")
    }
  }) : (this.lang == 'en') ? _c('img', {
    staticClass: "system_img",
    attrs: {
      "src": require("../../assets/about_us/system_en@2x.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "steps-1",
    attrs: {
      "current": _vm.current,
      "direction": "vertical"
    }
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('a', {
      staticClass: "font_mid tab_title",
      class: {
        active: index == _vm.num
      },
      staticStyle: {
        "color": "#99A9BF"
      },
      on: {
        "click": function($event) {
          _vm.tab(index)
        }
      }
    }, [(index == _vm.num) ? _c('img', {
      attrs: {
        "src": item.Showtitle
      }
    }) : _c('img', {
      attrs: {
        "src": item.title
      }
    })])
  }))]), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "height": "480px"
    },
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.tabContents), function(itemCon, index) {
    return _c('div', {
      staticClass: "tabCon"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.num),
        expression: " index == num"
      }],
      key: index,
      staticClass: "about-ifree-system-tabcon"
    }, [_c('div', {
      staticClass: "about-ifree-system-group"
    }, [_c('h1', [_vm._v(_vm._s(itemCon.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(itemCon.description))])])])])
  }))], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "travelution_ours"
  }, [_c('div', {
    staticClass: "travelution_ours_wrap"
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/home/new_home/vision_pic@2x.jpg")
    }
  })]), _vm._v(" "), _c('i-col', {
    attrs: {
      "lg": 12,
      "md": 12,
      "sm": 24,
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "font_big"
  }, [_vm._v(_vm._s(_vm.$t('travelution_vision')))]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v(_vm._s(_vm.$t('travelution_vision_content')))])])], 1)], 1)]), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3eda858","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tranvelution/Tranvelution.vue
// module id = 864
// module chunks = 0